import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileText } from "lucide-react";
import { api, extractError } from "@/lib/api";

// Admin editor for the Time Machine AI instructions (system prompt)
export function PromptCard() {
    const [st, setSt] = useState(null);
    const [text, setText] = useState("");
    const [busy, setBusy] = useState(false);
    const apply = (d) => { setSt(d); setText(d.content); };
    useEffect(() => { api.get("/integrations/tm-prompt").then((r) => apply(r.data)).catch((e) => toast.error(extractError(e))); }, []);
    if (!st) return null;
    const dirty = text !== st.content;
    const save = async () => {
        setBusy(true);
        try { apply((await api.put("/integrations/tm-prompt", { content: text })).data); toast.success("Istruzioni salvate: valgono dal prossimo resoconto generato"); }
        catch (e) { toast.error(extractError(e)); }
        finally { setBusy(false); }
    };
    const reset = async () => {
        if (!window.confirm("Ripristinare le istruzioni originali? Le tue modifiche andranno perse.")) return;
        apply((await api.delete("/integrations/tm-prompt")).data);
        toast.success("Istruzioni originali ripristinate");
    };
    return (
        <div className="bg-white border border-neutral-200 rounded-md p-5 flex items-start gap-4" data-testid="integration-tm-prompt">
            <FileText size={20} className="text-neutral-500 mt-0.5" />
            <div className="flex-1 min-w-0 space-y-2">
                <div className="font-semibold text-sm">Istruzioni per il resoconto AI</div>
                <div className="text-xs text-neutral-500" data-testid="tm-prompt-status">
                    {st.is_custom ? `Versione modificata${st.updated_at ? ` il ${new Date(st.updated_at).toLocaleString("it-IT")}` : ""}.` : "Versione originale."} Le modifiche valgono per i resoconti generati da ora: per aggiornare una data già salvata premi "Rigenera".
                </div>
                <textarea value={text} onChange={(e) => setText(e.target.value)} rows={18} data-testid="tm-prompt-textarea"
                    className="w-full text-sm leading-relaxed border border-neutral-200 rounded-md p-3 font-mono focus:outline-none focus:ring-1 focus:ring-neutral-400" />
                <div className="flex gap-2 justify-end">
                    {st.is_custom && <button onClick={reset} data-testid="tm-prompt-reset" className="text-xs px-3 py-1.5 rounded-md border border-neutral-200 hover:bg-neutral-50">Ripristina originale</button>}
                    {dirty && <button onClick={() => setText(st.content)} data-testid="tm-prompt-cancel" className="text-xs px-3 py-1.5 rounded-md border border-neutral-200 hover:bg-neutral-50">Annulla</button>}
                    <button onClick={save} disabled={busy || !dirty} data-testid="tm-prompt-save" className="text-xs px-3 py-1.5 rounded-md bg-neutral-900 text-white disabled:opacity-40">{busy ? "Salvataggio…" : "Salva istruzioni"}</button>
                </div>
            </div>
        </div>
    );
}
